import { startOfYesterday } from 'date-fns';
import { GET_ALL_PROJECTDATA,DELETE_PROJECT,SHOW_ALL_PROJECTS,SEARCH_PROJECTS,REFRENCE_DATA,CREATE_PROJECT,GET_ALL_DATA,VIEW_PROJECT } from '../actions/actionTypes';


const initialState = {CardData:[],CardItemData:[],CardItemDataFilter:[],UserName:'',showAllProject:false,refrenceData:[],getCardData:[],createprojectsucess:false,viewcardItemData:{}}

export default function project(state = initialState, action) {
    switch (action.type) {
        case GET_ALL_PROJECTDATA:
            return {
                ...state,
                CardData: action.getCardData,
                UserName: action.username,
                CardItemData: action.CardItemData,
                CardItemDataFilter: action.CardItemData,
                showAllProject: action.showAllProject,
                createprojectsucess:false,
                
            };
            case SEARCH_PROJECTS:
                return {
                    ...state,
                    CardItemDataFilter: action.filterdata,
                    
                   
            };
            case REFRENCE_DATA:
                return {
                    ...state,
                    refrenceData: action.referenceData,
                   
            };
            case CREATE_PROJECT:
                return {
                    ...state,
                    createprojectsucess:action.sucess,
                    
                   
            };
            case GET_ALL_DATA:
                return{
                    ...state,
                    getCardData: action.getCardData,
                };
                case VIEW_PROJECT:
                   return {
                    ...state,
                    viewcardItemData: action.data,
                    }
           
          default:
            return state
    }
}
